export default class SingleArrayResponseService {
    /**
     * returns the data from a single array response and throws an error if data type is not array
     *
     * @param {SingleArrayResponse<T>} singleArrayResponse
     * @throws {Error} when the data type is not array
     * @returns {T} data from the single array response
     * */
    static processSingleArrayResponse(singleArrayResponse) {
        if (Array.isArray && !Array.isArray(singleArrayResponse)) {
            if (console.error) {
                console.error(singleArrayResponse);
            }
            // @ts-expect-error - TS2339 - Property 'toString' does not exist on type 'never'.
            throw "Invalid single array response: " + singleArrayResponse.toString();
        }
        // @ts-expect-error - TS2322 - Type 'SingleArrayResponse<T>' is not assignable to type 'T'.
        return singleArrayResponse;
    }
}
